import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getListAnnouncement = async (params) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V1}/announcements/office${newParams}`);
};
